import BaseMotorCard from './BaseMotorCard';
import { DeviceCardProps } from '../DeviceCardProps';
import { HighSpeedMotorIcon } from '../../../Icons/Bits';
import { MOTOR_TYPE } from '../../../../utils/constants';

interface HighSpeedMotorCardProps extends DeviceCardProps {
  id: string;
  header: string;
}

const HighSpeedMotorCard = (props: HighSpeedMotorCardProps) => {
  return <BaseMotorCard {...props} headerIcon={HighSpeedMotorIcon} motorType={MOTOR_TYPE.HIGH_SPEED} />;
};

export default HighSpeedMotorCard;
